export type BreakingTickerArticle = { id: number; title: string };

export function getBreakingTickerArticles(breaking: BreakingTickerArticle[] | undefined, articles: BreakingTickerArticle[]) {
  const source = breaking?.length ? breaking : articles;
  return [...source, ...source];
}
